import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalConfig } from '../../modal-config';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-view',
  templateUrl: './modal-view.component.html',
  styleUrls: ['./modal-view.component.scss']
})
export class ModalViewComponent {
  lang: string
  @Input() config!: ModalConfig;
  @Output() close = new EventEmitter<void>();
  count = 0;
  latitude = parseFloat(localStorage.getItem('schoolLat'))
  longitude = parseFloat(localStorage.getItem('schoolLong'))
  mapControls
  @ViewChild('studentModalChild') studentModalChild!:any;
  @ViewChild('parentModalChild') parentModalChild!:any;
  @ViewChild('assistantModalChild') assistantModalChild!:any;
  @ViewChild('otpModalChild') otpModalChild!:any;
  @ViewChild('addParentModalChild') addParentModalChild!:any;
  saveDisabled = false;
  private formStatusSub;

  /**
   * Drives the Add Parent header buttons. A plain field, not a read through
   * the view query: the query resolves after the header has been checked, so
   * binding to it directly would change what was just checked.
   */
  // step 0 until the child reports: better a header with no button for a frame
  // than one belonging to the wrong step
  createParentHeader = { step: 0, canContinue: false, saveBlocked: true, saving: false };

  constructor(private translate: TranslateService,
    private cdr: ChangeDetectorRef,
  ) { }
  ngOnInit() {
    console.log('genericView', this.config);
    this.lang = localStorage.getItem('lang');
    this.initMapControls();
  }

  ngOnDestroy() {
    this.formStatusSub?.unsubscribe();
    console.log('geniricModalDestroyed')
  }

  getFormControls(): string[] {
    this.count++
    console.log('count', this.count);
    console.log('controls', Object.keys(this.config.formGroup.controls));
    return Object.keys(this.config.formGroup.controls);
  }

  getLabelForControl(controlName: string): string {
    const control = this.config.formGroup.get(controlName);
    return control ? this.translate.instant((control as any).translationKey) : '';
  }

  getErrorMessage(control: string): string {
    const errors = this.config.formGroup.controls[control].errors;
    if (errors?.required) {
      return 'This field is required';
    }
    if (errors?.pattern) {
      return 'Invalid format';
    }
    return '';
  }

  initMapControls() {
    this.mapControls = {
      mapPoint: {
        lat: this.latitude,
        long: this.longitude,
      }
    }
  }

  getModalTitle(mode) {
    switch (mode) {
      case 'add':
        return this.config?.title?.addKey;
      case 'edit':
        return this.config?.title?.editKey;
      case 'view':
        return this.config?.title?.viewKey;
      default:
        return this.config?.title?.defaultKey;
    }
  }

  testChilds(){
    console.log('studentChild' , this.studentModalChild);
    console.log('parentChild' , this.parentModalChild);
  }

  // the save action lives in the header so the modal body gets the footer space
  saveFromHeader(openedModalType) {
    switch (openedModalType) {
      case 'parent':
        this.parentModalChild?.saveParent();
        break;
      default:
        break;
    }
  }

  ngAfterViewInit() {
    const form = this.parentModalChild?.addParentForm;
    if (!form) {
      return;
    }
    // deferred so the disabled state never changes inside the same change
    // detection pass that just checked the binding
    const sync = () => {
      if (!!form.invalid !== this.saveDisabled) {
        this.saveDisabled = !!form.invalid;
        this.cdr.detectChanges();
      }
    };
    setTimeout(sync);
    this.formStatusSub = form.statusChanges.subscribe(() => setTimeout(sync));
  }

  /**
   * Deferred, so the header buttons never change inside the same change
   * detection pass that just checked them — the child reports its state while
   * that pass is still running.
   */
  onCreateParentHeaderState(state) {
    setTimeout(() => this.createParentHeader = state);
  }

  toggleActivation(openedModalType){
    switch (openedModalType) {
        case 'parent':
        this.parentModalChild?.changeActivation();
        break;
        case 'staff':
        break;
      default:
        break;
    }

  }
}
